import { defineMessages, useIntl } from 'react-intl';
import { Stack, styled } from '@mui/material';
import type { SxProps } from '@mui/material';
import { ProjectsIcon, SurveysIcon } from '../icons';

const messages = defineMessages({
    numberOfProjects: {
        defaultMessage: 'Number of projects',
    },
    numberOfSurveys: {
        defaultMessage: 'Number of surveys',
    },
});

const Icon = styled('div')<{ adjust: number }>(({ theme, adjust }) => ({
    color: theme.palette.text.secondary,
    transform: `translateY(${adjust}px)`,
}));
const Count = styled('div')(({ theme }) => ({
    color: theme.palette.text.primary,
    fontSize: 12,
    fontWeight: 'bold',
}));

export default function FilterStats({
    projectsSize = null,
    surveysSize = null,
    sx,
    className,
}: {
    projectsSize?: number | null | undefined;
    surveysSize?: number | null | undefined;
    sx?: SxProps;
    className?: string; // deprecated, use sx
}) {
    const { formatMessage } = useIntl();
    return (
        <Stack
            direction="row"
            gap={2}
            pt="2px"
            sx={sx}
            flexWrap="nowrap"
            className={className}
        >
            {typeof projectsSize === 'number' && (
                <Stack
                    direction="row"
                    gap={1}
                    flexWrap="nowrap"
                    alignItems="center"
                    title={formatMessage(messages.numberOfProjects)}
                >
                    <Icon adjust={-2}>
                        <ProjectsIcon />
                    </Icon>
                    <Count>{projectsSize}</Count>
                </Stack>
            )}
            {typeof surveysSize === 'number' && (
                <Stack
                    direction="row"
                    gap={1}
                    flexWrap="nowrap"
                    alignItems="center"
                    title={formatMessage(messages.numberOfSurveys)}
                >
                    <Icon adjust={-4}>
                        <SurveysIcon />
                    </Icon>
                    <Count>{surveysSize}</Count>
                </Stack>
            )}
        </Stack>
    );
}
